module.exports = "<span class=\"min-chart\">\n  <span class=\"percent\">{{ percent }}</span>\n  <mdb-easy-pie-chart [percent]=\"percent\" [options]=\"options\"></mdb-easy-pie-chart>\n</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/typescripts/pro/easy-charts/chart-simple.component.html
// module id = ./src/app/typescripts/pro/easy-charts/chart-simple.component.html
// module chunks = main